// extracted by mini-css-extract-plugin
module.exports = {"fullGridView":"PublisherChat_fullGridView__3Ab1m","hidden":"PublisherChat_hidden__HtUKq"};